import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortString',
})
export class SortStringPipe implements PipeTransform {
  transform(listArray: any[] | null | undefined, field: string | undefined, order: 'asc' | 'desc' = 'asc'): any[] {
    if(!listArray) {
      return [];
    }
    if(!field) {
      return listArray;
    }

    const array = [...listArray];
    const sortOrder = order === 'asc' ? 1 : -1;
    const handler = {
      get(target: any, prop: string) {
        const keys = prop.split('.');
        let value = target;

        for(const key of keys) {
          if(value && Object.hasOwn(value, key)) {
            value = value[key];
          }
          else {
            return '';
          }
        }
        return value;
      }
    };

    return array.sort((a, b) => {
      const aProxy = new Proxy(a, handler);
      const bProxy = new Proxy(b, handler);
      if(!aProxy[field] || !bProxy[field]) {
        return 0;
      }
      return aProxy[field].toLowerCase() > bProxy[field].toLowerCase() ? sortOrder : -1 * sortOrder;
    });
  }
}
